function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ControlsTemplate = require('./controls.template');
var Controls = /*#__PURE__*/function () {
  function Controls(app, mod) {
    _classCallCheck(this, Controls);
    this.app = app;
    this.mod = mod;
    this.opts = null;
    this.raise_increment = 0;
  }
  return _createClass(Controls, [{
    key: "render",
    value: function render() {
      if (!this.mod.gameBrowserActive() && !this.mod.browser_active) {
        return;
      }
      if (!document.querySelector('.poker-controls')) {
        this.app.browser.addElementToSelector(ControlsTemplate(), '.poker-play');
      }
      if (!this.bound) {
        this.bindRaiseSheet();
        this.bound = true;
      }
    }
  }, {
    key: "bindRaiseSheet",
    value: function bindRaiseSheet() {
      var _this = this;
      var range = document.getElementById('poker-raise-range');
      var cancel = document.getElementById('poker-raise-cancel');
      var confirm = document.getElementById('poker-raise-confirm');
      if (range) {
        range.oninput = function () {
          _this.raise_increment = parseInt(range.value, 10);
          _this.updateRaiseAmount();
        };
      }
      if (cancel) {
        cancel.onclick = function () {
          return _this.closeRaiseSheet();
        };
      }
      if (confirm) {
        confirm.onclick = function () {
          return _this.confirmRaise();
        };
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this$mod;
      var host = document.getElementById('poker-controls');
      var row = document.getElementById('poker-control-row');
      if (row) {
        row.innerHTML = '';
      }
      if (host) {
        host.classList.remove('is-active');
      }
      var main = document.getElementById('poker-main');
      if (main) {
        main.classList.remove('is-your-move');
      }
      if ((_this$mod = this.mod) !== null && _this$mod !== void 0 && _this$mod.result) {
        this.mod.result.clearAcknowledge();
        this.mod.result.hide();
      }
      this.closeRaiseSheet();
    }
  }, {
    key: "showPrimary",
    value: function showPrimary(opts) {
      var _this$mod2,
        _this2 = this;
      this.render();
      this.opts = opts;
      var host = document.getElementById('poker-controls');
      var row = document.getElementById('poker-control-row');
      if (!row || !host) {
        return;
      }
      this.closeRaiseSheet();
      row.innerHTML = '';
      if ((_this$mod2 = this.mod) !== null && _this$mod2 !== void 0 && _this$mod2.result) {
        this.mod.result.clearAcknowledge();
      }
      this.addArtifact(row, {
        action: 'fold',
        title: 'Fold',
        icon: '/poker/img/actions/fold.svg',
        onClick: function onClick() {
          return _this2.fold();
        }
      });
      if (opts.match_required > 0) {
        this.addArtifact(row, {
          action: 'call',
          title: 'Call',
          detail: this.mod.formatWager(opts.match_required, true),
          icon: '/poker/img/actions/call.svg',
          onClick: function onClick() {
            return _this2.call();
          }
        });
      } else {
        this.addArtifact(row, {
          action: 'check',
          title: 'Check',
          icon: '/poker/img/actions/call.svg',
          onClick: function onClick() {
            return _this2.check();
          }
        });
      }
      if (opts.can_raise) {
        this.addArtifact(row, {
          action: 'raise',
          title: 'Raise',
          icon: '/poker/img/actions/raise.svg',
          onClick: function onClick() {
            return _this2.showRaise();
          }
        });
      }
      host.classList.remove('is-active');
      var main = document.getElementById('poker-main');
      if (main) {
        main.classList.add('is-your-move');
      }
      requestAnimationFrame(function () {
        host.classList.add('is-active');
      });
    }
  }, {
    key: "addArtifact",
    value: function addArtifact(row, spec) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'poker-artifact';
      btn.dataset.action = spec.action;
      btn.innerHTML = "<img class=\"poker-artifact-icon\" src=\"".concat(spec.icon, "\" alt=\"\">\n      <span class=\"poker-artifact-copy\">\n        <span class=\"poker-artifact-title\">").concat(spec.title, "</span>\n        ").concat(spec.detail ? "<span class=\"poker-artifact-detail\">".concat(spec.detail, "</span>") : '', "\n      </span>");
      btn.onclick = spec.onClick;
      row.appendChild(btn);
    }
  }, {
    key: "showRaise",
    value: function showRaise() {
      var opts = this.opts;
      var sheet = document.getElementById('poker-raise-sheet');
      var range = document.getElementById('poker-raise-range');
      var presets = document.getElementById('poker-raise-presets');
      if (!opts || !sheet || !range || !presets) {
        return;
      }
      this.raise_increment = opts.last_raise;
      range.min = String(opts.last_raise);
      range.max = String(opts.max_raise);
      range.step = '1';
      range.value = String(opts.last_raise);
      this.updateRaiseAmount();
      presets.innerHTML = '';
      for (var i = 0; i < 3; i++) {
        var this_raise = opts.last_raise * Math.pow(2, i);
        if (opts.max_raise > this_raise) {
          this.addPreset(presets, this_raise, this.mod.formatWager(this_raise, true));
        } else {
          break;
        }
      }
      this.addPreset(presets, opts.max_raise, 'All-in');
      sheet.hidden = false;
    }
  }, {
    key: "addPreset",
    value: function addPreset(host, increment, label) {
      var _this3 = this;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'poker-raise-preset';
      btn.innerHTML = label;
      btn.onclick = function () {
        _this3.raise_increment = increment;
        var range = document.getElementById('poker-raise-range');
        if (range) {
          range.value = String(increment);
        }
        _this3.updateRaiseAmount();
      };
      host.appendChild(btn);
    }
  }, {
    key: "updateRaiseAmount",
    value: function updateRaiseAmount() {
      var el = document.getElementById('poker-raise-amount');
      if (!el || !this.opts) {
        return;
      }
      el.innerHTML = this.mod.formatWager(this.raise_increment, true);
    }
  }, {
    key: "closeRaiseSheet",
    value: function closeRaiseSheet() {
      var sheet = document.getElementById('poker-raise-sheet');
      if (sheet) {
        sheet.hidden = true;
      }
    }
  }, {
    key: "confirmRaise",
    value: function confirmRaise() {
      var opts = this.opts;
      if (!opts) {
        return;
      }
      var amt = parseInt(this.raise_increment, 10);
      if (amt >= opts.last_raise && amt <= opts.max_raise) {
        this.closeRaiseSheet();
        this.raise(amt + opts.match_required);
      }
    }
  }, {
    key: "fold",
    value: function () {
      var _fold = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var c;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(this.opts && !this.opts.match_required)) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return sconfirm('Are you sure you want to fold?');
            case 1:
              c = _context.v;
              if (c) {
                _context.n = 2;
                break;
              }
              this.showPrimary(this.opts);
              return _context.a(2);
            case 2:
              this.mod.addMove("fold\t".concat(this.mod.game.player));
              this.mod.endTurn();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function fold() {
        return _fold.apply(this, arguments);
      }
      return fold;
    }()
  }, {
    key: "check",
    value: function check() {
      this.mod.addMove("check\t".concat(this.mod.game.player));
      this.mod.endTurn();
    }
  }, {
    key: "call",
    value: function call() {
      this.mod.addMove("call\t".concat(this.mod.game.player));
      this.mod.endTurn();
    }
  }, {
    key: "raise",
    value: function raise(total) {
      this.mod.addMove("raise\t".concat(this.mod.game.player, "\t").concat(total));
      this.mod.endTurn();
    }
  }]);
}();
module.exports = Controls;